import { BreadCrumb, Banner } from "../../components/shared/index";
import { useLocation } from "react-router-dom";
import styles from './termsconditions.module.css'
function Refundpolicy(){
     const { pathname } = useLocation();
  const parts = pathname.split("/");
  const newPath = parts[parts.length - 2];

    return ( 
        <> 
       <section className={styles.refund__wrapper}>
  <BreadcrumbBanner
    newPath={newPath}
    heading="Return & Refund Policy -GDRB Fashion"
    imageUrl="https://t4.ftcdn.net/jpg/00/54/28/13/240_F_54281395_N3triftG95Jife551rlnzHj6InhpEk9S.jpg"
  />

  <div className={styles.refund__content}>
    <div>
      <h2>Return & Refund Policy –GDRB Fashion</h2>
      <p>
        AtGDRB Fashion customer satisfaction is our top priority...
      </p>
    </div>

    <div>
      <h3>7-Day Easy Return Policy</h3>
      <ul>
        <li>Customers can request a return <b>within 7 days of receiving the product</b></li>
        <li>The item must be <b>unused, undamaged, and in its original packaging.</b></li>
        <li>Returns are accepted for manufacturing defects, wrong items delivered, or if the product does not match the description.</li>
        <li>Once the returned item reaches us and passes the quality check, we will process your refund.</li>
      </ul>
    </div>

    <div>
      <h3>Refund Policy</h3>
      <ul>
        <li>Refunds are initiated <b>within 3–7 business days</b> after approval.</li>
        <li>Refunds will be credited to your <b>original mode of payment</b> (Bank, UPI, Wallet, or Card).</li>
        <li>For COD orders, valid bank details may be requested.</li>
      </ul>
    </div>

    <div>
      <h3>Non-Returnable Items</h3>
      <p>
        For hygiene and safety reasons, certain items like pierced jewellery, customized products, or heavily discounted items may not be eligible for return unless defective.
      </p>
    </div>

    <div>
      <h3>Easy Return Process</h3>
      <p>1. Contact our customer support within 7 days.</p>
      <p>2. Mail on info@gdrbtechnologies.com.</p>
      <p>3. Our team will guide you through the return process.</p>
      <p>4. Once we receive and verify the product, your refund will be initiated.</p>
    </div>
  </div>
</section>

        </>
    )
}  
const BreadcrumbBanner = ({ newPath, heading, imageUrl }) => (
  <>
    <BreadCrumb customPaths={[{ label: "refund Policy", path: newPath }]} />
    <Banner heading={heading} imageUrl={imageUrl} />
  </>
);
export default Refundpolicy;